<script setup lang="ts">
import { type Notification, NOTIFICATION_TYPE } from '~/composables/notifications';

const props = defineProps<{
  notification: Notification
  duration?: number
}>();

const { remove } = useNotifications();
function removeCurrentNotification() {
  remove(props.notification.id);
}
useTimeoutFn(removeCurrentNotification, props.duration ?? 5000);
</script>

<template>
  <div
    class="flex items-center gap-m px-m py-s rounded-lg shadow-md w-full text-white"
    :class="notification?.type === NOTIFICATION_TYPE.Error ? `bg-error` : `bg-black`"
  >
    <span
      class="flex-1 font-semibold"
      v-text="notification?.message"
    />
    <div class="flex-none">
      <IadBtn
        variant="outlined"
        icon
        size="small"
        @click="removeCurrentNotification"
      >
        <Icon
          name="iad-icon:close"
        />
      </IadBtn>
    </div>
  </div>
</template>
